import { GlAvatar, GlAvatarLink, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'DeploymentTriggerer',
    components: {
        GlAvatar,
        GlAvatarLink
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        triggerer: {
            type: Object,
            required: false,
            default: null
        }
    }
};
